export default __webpack_public_path__ + "static/media/buylowsellhigh.bc078c10.jpg";